"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStartDictate;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStartDictate() {
  return (0, _useWebChatAPIContext.default)().startDictate;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTdGFydERpY3RhdGUudHMiXSwibmFtZXMiOlsidXNlU3RhcnREaWN0YXRlIiwic3RhcnREaWN0YXRlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxlQUFULEdBQXVDO0FBQ3BELFNBQU8scUNBQXVCQyxZQUE5QjtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVN0YXJ0RGljdGF0ZSgpOiAoKSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuc3RhcnREaWN0YXRlO1xufVxuIl19